import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

const AuthenticityGuarantee: FC = () => (
    <FormattedMessage
        id="useBuyerIncentivesMessages.authenticityGuarantee"
        defaultMessage="Authenticity Guarantee"
    />
);

const Cancellation: FC = () => (
    <FormattedMessage
        id="useBuyerIncentivesMessages.cancelationPolicy"
        defaultMessage="24-Hour Cancellation"
    />
);

export const MoneyBack: FC = () => (
    <FormattedMessage
        id="useBuyerIncentivesMessages.moneyBackGuarantee"
        defaultMessage="Money-Back Guarantee"
    />
);

const VettedSellers: FC = () => (
    <FormattedMessage
        id="useBuyerIncentivesMessages.vettedSellers"
        defaultMessage="Vetted Professional Sellers"
    />
);

const PriceMatch: FC = () => (
    <FormattedMessage
        id="useBuyerIncentivesMessages.priceMatch"
        defaultMessage="Price-Match Guarantee"
    />
);

const GlobalDelivery: FC = () => (
    <FormattedMessage
        id="useBuyerIncentivesMessages.globalDelivery"
        defaultMessage="Trusted Global Delivery"
    />
);

export const useBuyerIncentivesMessages = ({
    useAll = false,
}: {
    useAll?: boolean;
} = {}): ReactNode[] => {
    const coreIncentives = [<AuthenticityGuarantee />, <MoneyBack />, <Cancellation />];
    if (!useAll) {
        return coreIncentives;
    }

    return [...coreIncentives, <VettedSellers />, <PriceMatch />, <GlobalDelivery />];
};
